import React from 'react';
import { Link, Outlet } from 'react-router-dom';

const AdminLayout = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-gray-200">
      <nav className="border-b border-gray-700 bg-gray-800/80 px-4 py-3">
        <div className="flex items-center gap-4">
          <Link
            to="/admin"
            className="text-sm font-medium text-blue-400 hover:text-blue-300"
          >
            Threads
          </Link>
          <Link
            to="/admin/proposals"
            className="text-sm font-medium text-blue-400 hover:text-blue-300"
          >
            Proposals
          </Link>
          <Link
            to="/"
            className="text-sm text-gray-400 hover:text-gray-300"
          >
            Back to Chat
          </Link>
        </div>
      </nav>
      <main className="p-4">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
